import { render, staticRenderFns } from "./NotificationDisplay.vue?vue&type=template&id=1c667072&scoped=true&"
import script from "./NotificationDisplay.vue?vue&type=script&lang=ts&"
export * from "./NotificationDisplay.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationDisplay.vue?vue&type=style&index=0&id=1c667072&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c667072",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCardActions,VContainer})
